import io from 'socket.io-client';
import { v4 } from 'uuid';
import { store } from '../config/configureStore';
import { loadCategories } from '../views/menu/actions';
import { Memoize } from './memoize';
import {
  RTD_INITIALIZE,
  MENU_ITEM_AVAILABILITY,
  MODIFIER_AVAILABILITY,
  FORCED_MODIFIER_AVAILABILITY,
} from '../redux/constants/actionTypes';

// store unique deviceId in storage location.
let deviceId = localStorage.getItem('deviceId');
if (!deviceId) {
  deviceId = v4();
  localStorage.setItem('deviceId', deviceId);
}
let socket;
export const initSocket = encDataname => {
  if (!encDataname) {
    return;
  }
  socket && socket.disconnect();
  socket = io(process.env.REACT_APP_KRAKEN_URL, {
    query: `name=${encDataname}&deviceId=${deviceId}`,
  });
  window.socket = socket;

  socket.on('new.connection', () => {
    // Reload All menu items.
    newconnection();
  });
  socket.on('menu.items.status', data => {
    data.forEach(item => {
      store.dispatch({
        type: MENU_ITEM_AVAILABILITY,
        id: item.id,
        unavailableUntil: item.unavailableUntil,
      });
    });
  });
  socket.on('modifiers.status', data => {
    data.forEach(item => {
      store.dispatch({
        type: MODIFIER_AVAILABILITY,
        id: item.id,
        unavailableUntil: item.unavailableUntil,
      });
    });
  });
  socket.on('forced.modifiers.status', data => {
    data.forEach(item => {
      store.dispatch({
        type: FORCED_MODIFIER_AVAILABILITY,
        id: item.id,
        unavailableUntil: item.unavailableUntil,
      });
    });
  });

  socket.on('connect', () => {
    console.log('CONNECTED');
  });
  socket.on('disconnect', () => {
    console.log('DISCONNECTED');
  });
};

const newconnection = () => {
  store.dispatch({
    type: RTD_INITIALIZE,
  });
  Memoize.replay('menu_items');
  Memoize.replay('modifiers');
};



// WEBPACK FOOTER //
// ./src/socket/index.js